import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useImperativeHandle, useState } from "react";
import { Spin } from "antd";
import { axiosErrorHandler } from "../../../../../swzutils";
import DashboardResource from "../api/DashboardResource";
import DeliveriesByVehicleTypeTable from "./DeliveriesByVehicleTypeTable";
const DeliveriesByVehicleTypeWidget = (props, exportedRef) => {
    const [stateLoading, setStateLoading] = useState(false);
    const [stateData, setStateData] = useState(null);
    useImperativeHandle(exportedRef, () => {
        return {
            refresh
        };
    });
    // useEffect(() => {
    //     refresh()
    // }, []);
    // useEffect(() => {
    //     if (props.date) {
    //         refresh();
    //     }
    // }, [props.date]);
    const refresh = () => {
        loadDeliveriesByVehicleType();
    };
    const loadDeliveriesByVehicleType = () => {
        setStateLoading(true);
        DashboardResource.loadDeliveriesByVehicleType(props.date, response => setStateData(response), axiosErrorHandler, () => setStateLoading(false));
    };
    return (_jsx(Spin, { spinning: stateLoading, children: _jsxs("div", { className: "widget", children: [_jsx("h2", { children: "Deliveries by Vehicle Type" }), stateData
                    ? _jsx(DeliveriesByVehicleTypeTable, { deliveriesByVehicleType: stateData })
                    : _jsx(_Fragment, { children: "\u2014" })] }) }));
};
export default React.forwardRef(DeliveriesByVehicleTypeWidget);
